import { syncCart, clearCart } from "../../utils/api";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { SET_PORTAL_API } from "./portal_actions";
import { TITLE_ERROR } from "../../utils/constants";


export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const REMOVE_PRODUCT_FROM_CART = 'REMOVE_PRODUCT_FROM_CART';
export const REMOVE_ACTIVE_PRODUCTS = 'REMOVE_ACTIVE_PRODUCTS';
export const INCREMENT_PRODUCT = 'INCREMENT_PRODUCT';
export const DECREMENT_PRODUCT = 'DECREMENT_PRODUCT';
export const CLEAR_CART = 'CLEAR_CART';
export const SET_ACTIVE_PRODUCT = 'SET_ACTIVE_PRODUCT';
export const RESET_ACTIVE_PRODUCT = 'RESET_ACTIVE_PRODUCT';
export const SET_ALL_ACTIVE = 'SET_ALL_ACTIVE';
export const RESET_ALL_ACTIVE = 'RESET_ALL_ACTIVE';
export const SYNC_CART_WITH_SERVER = 'SYNC_CART_WITH_SERVER';
export const UPDATE_CART_ON_SERVER = 'UPDATE_CART_ON_SERVER';
export const REQUEST_CART_FAILED = 'REQUEST_CART_FAILED';


export const putSyncCartThunk = (accessToken, refreshToken, cart) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    syncCart(accessToken, refreshToken, 'PUT', cart)
      .then(data => {
        dispatch({ type: SYNC_CART_WITH_SERVER, payload: data });
      })
      .catch(error => {
        dispatch({ type: REQUEST_CART_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
        console.log(error);
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });

  }
}

export const patchSyncCartThunk = (accessToken, refreshToken, cart) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: SYNC_CART_WITH_SERVER, payload: cart });
    syncCart(accessToken, refreshToken, 'PATCH', cart)
      .then(data => {
        dispatch({
          type: SYNC_CART_WITH_SERVER,
          payload: data
        });
      })
      .catch(error => {
        dispatch({ type: REQUEST_CART_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
        console.log(error);
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const clearCartThunk = (accessToken, refreshToken) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: CLEAR_CART });
    clearCart(accessToken, refreshToken)
      .then(data => {
      })
      .catch(error => {
        dispatch({ type: REQUEST_CART_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
        console.log(error);
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const removeActiveFromCartThunk = (accessToken, refreshToken, cart) => {
  return function (dispatch) {
    dispatch({ type: START_LOADING });
    dispatch({ type: REMOVE_ACTIVE_PRODUCTS });
    syncCart(accessToken, refreshToken, 'PUT', cart)
      .then(data => {
        dispatch({ type: SYNC_CART_WITH_SERVER, payload: data });
      })
      .catch(error => {
        dispatch({ type: REQUEST_CART_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
        console.log(error);
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
